import { render } from "./MainPage.vue?vue&type=template&id=0e6df82a&scoped=true&ts=true"
import script from "./MainPage.vue?vue&type=script&lang=ts"
export * from "./MainPage.vue?vue&type=script&lang=ts"

import "./MainPage.vue?vue&type=style&index=0&id=0e6df82a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e6df82a"]])

export default __exports__